exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sombrarredondada {\n  background-color: #999;\n  color: #5a5a5a;\n  -moz-border-radius: 7px;\n  -webkit-border-radius: 7px;\n  box-shadow: 5px -5px 2px  #999;\n  -webkit-box-shadow: 5px -5px 2px  #999;\n  -moz-box-shadow: 5px -5px 2px  #999; }\n\n.sombraclara {\n  width: 200px;\n  padding: 10px;\n  background-color: #999;\n  color: #fff;\n  box-shadow: 2px 2px 2px #ffc;\n  -webkit-box-shadow: 2px 2px 2px #ffc;\n  -moz-box-shadow: 2px 2px 2px #ffc; }\n\n.sombra1 {\n  background-color: #ddd;\n  width: 300px;\n  padding: 10px;\n  box-shadow: 5px 5px 0 #333;\n  -webkit-box-shadow: 5px 5px 0 #333;\n  -moz-box-shadow: 5px 5px 0 #333; }\n\n.corFundo1 {\n  background-color: #01B32B;\n  color: #FEFEFE; }\n\n.corFundo2 {\n  background-color: #585A57;\n  color: #FEFEFE; }\n\n.letra {\n  background-color: #FEFEFE; }\n\n.botao {\n  background-color: #007AD9;\n  color: #FEFEFE; }\n\n.texto-cor {\n  color: #585A57; }\n\n.texto-sombra-inverso {\n  text-shadow: 1px -2px black; }\n\n.texto-sombra {\n  text-shadow: 1px -2px #007AD9; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/app/login/login.component.scss
// module id = ../../../../../src/app/login/login.component.scss
// module chunks = main